import React, { Component } from "react";
import PageDesigner from "../page_designer/PageDesigner";
import ApiManager from "../../managers/ApiManager";
import { DKIcon, DKLabel, removeLoader } from "deskera-ui-library";
import ApiConstants from "../../constants/ApiConstants";
import no_page_found from "../../assets/empty_state/no_page_found.png";

class PublicPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: undefined,
      type: undefined,
      dataType: "html",
      noRecordFound: false,
    };
  }

  componentDidMount() {
    this.setScriptTag();
    const id = this.props.match.params.id;
    ApiManager.getPublicPageJSONData(
      id,
      (data) => {
        this.setState({
          type: data.type,
          data: data.data,
          dataType: data.dataType,
          noRecordFound: data.noRecordFound,
        });
        removeLoader();
      },
      (err) => {
        removeLoader();
        this.setState({
          noRecordFound: true,
        });
      }
    );
  }

  getPageType() {
    return this.state.type.toLowerCase();
  }

  setScriptTag() {
    let script = document.createElement("script");
    script.src = ApiConstants.FORM_SUBMISSION_URL;
    document.body.appendChild(script);

    let script_tag = document.createElement("script");
    script_tag.src = ApiConstants.LOAD_SCRIPTS_URL
    document.body.appendChild(script_tag);
  }

  render() {
    return (
      <div className="parent-width screen-height bg-white">
        {this.state.noRecordFound && (
          <div
            className={"column  justify-content-center align-items-center"}
            style={{ height: "100%" }}
          >
            <DKIcon src={no_page_found} className="" style={{ height: 110 }} />
            <DKLabel className="fw-m fs-l mt-m" text="No page found!" />
            <DKLabel
              className="mt-s text-align-center text-dark-gray"
              text="The page you tried to visit does not exist or in-active,<br/>please check the url again or contact the owner of this page"
            />
          </div>
        )}
        {this.state.data && this.state.dataType === "json" && (
          <PageDesigner
            previewMode={true}
            type={this.getPageType()}
            components={JSON.parse(this.state.data)}
          />
        )}
        {this.state.data && this.state.dataType === "html" && (
          <div dangerouslySetInnerHTML={{ __html: this.state.data }} />
        )}
      </div>
    );
  }
}

export default PublicPage;
